import styles from './StickyAddTo.module.scss';

export const selectCustomeStyles = {
  selectField: styles.selectField,
  selectDropdown: styles.selectDropdown,
  after: styles.after,
};

export const theme = "Sportscraft"